import React from 'react';
import PropTypes from 'prop-types';

import { Button, Icon, Label } from '@atlas/ui';

import { OAUTH_FLOW_TYPES } from 'common/constants';
import FormWithCaptcha from 'common/Form/FormWithCaptcha/FormWithCaptcha';
import Stepper from 'components/Stepper/Stepper';
import SocialProviders from 'src/components/SignUp/SocialProviders';

const SignUpFormBody = ({
  action,
  activeStep,
  activeType,
  fields,
  flowType,
  formRef,
  hideSocialProviders = false,
  isBackButtonVisible,
  isLastStep = false,
  onBackHandler,
  onTrackedFieldChanges,
  shouldShowStepper,
  showSignInLink,
  signInLink,
  socialProviders = [],
  stepsAmount = 0,
  trackedFields,
}) => {
  return (
    <>
      {shouldShowStepper && <Stepper activeStep={activeStep} stepsAmount={stepsAmount} />}
      <FormWithCaptcha
        action={action}
        buttonClassName="submit-button"
        buttonId="signUp"
        buttonText={isLastStep ? 'registration' : 'next'}
        form={{ fields, number: activeStep }}
        formType={activeType}
        id={activeType.id}
        isSubmitButtonAlwaysEnabled
        key={activeType.id}
        leftSideSubmitContent={
          isBackButtonVisible && (
            <Button onClick={onBackHandler} size="big" type="secondary">
              <Icon height={20} name="arrow-left" width={20} />
              <Label message="step_number" params={{ number: activeStep }} />
            </Button>
          )
        }
        onTrackedFieldChanges={onTrackedFieldChanges}
        ref={formRef}
        trackedFields={trackedFields}
        validateRequestHeaders={{
          'Time-Zone': Intl.DateTimeFormat().resolvedOptions().timeZone,
        }}
      />
      {activeStep === 0 && !hideSocialProviders && (
        <SocialProviders flowType={flowType} items={socialProviders} />
      )}
      {showSignInLink && (
        <div className="sign-in-footer">
          <div>
            <Label className="title-300-text" message="Already member" />
            {signInLink}
          </div>
        </div>
      )}
    </>
  );
};

SignUpFormBody.propTypes = {
  action: PropTypes.func.isRequired,
  activeStep: PropTypes.number.isRequired,
  activeType: PropTypes.object.isRequired,
  fields: PropTypes.arrayOf(PropTypes.object).isRequired,
  flowType: PropTypes.oneOf([OAUTH_FLOW_TYPES.SIGNUP, OAUTH_FLOW_TYPES.SIGNUP_MULTISTEP]),
  formRef: PropTypes.object,
  hideSocialProviders: PropTypes.bool,
  isBackButtonVisible: PropTypes.bool.isRequired,
  isLastStep: PropTypes.bool,
  onBackHandler: PropTypes.func.isRequired,
  onTrackedFieldChanges: PropTypes.func.isRequired,
  shouldShowStepper: PropTypes.bool.isRequired,
  showSignInLink: PropTypes.bool.isRequired,
  signInLink: PropTypes.node.isRequired,
  socialProviders: PropTypes.arrayOf(PropTypes.object),
  stepsAmount: PropTypes.number,
  trackedFields: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default SignUpFormBody;
